import TermLengths from './TermLengths';
import AboutData from './AboutData';
import HowToPurchaseData from './HowToPurchaseData';
import HowDoesItWork from './HowDoesItWorkData';
import WhoIsThisProductFor from './WhoIsThisProductData';
import HowIsItUsed from './HowIsItUsedData';

export default function TermData() {
  const minAge = 18;
  const maxAge = 79;
  const minCoverageAmount = 50000;
  const maxCoverageAmount = 500000;

  return {
    name: 'Traditional Long-Term Care',
    subtitle: '',
    specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount },
    },
    hyperlinks: [
      {
        title: 'ABOUT',
        link: 'about'

      },
      {
        title: 'HOW DOES IT WORK',
        link: 'howDoesItWork',
      },
      {
        title: 'WHO IS THIS PRODUCT FOR',
        link: 'whoIsThisProductFor',
      },
      {
        title: 'HOW TO PURCHASE',
        link: 'howToPurchase',
      }
    ],
    about: AboutData(TermLengths()),
    howToPurchase: HowToPurchaseData(),
    howDoesItWorkData: HowDoesItWork(),
    WhoIsThisProductData: WhoIsThisProductFor(),
    HowIsItUsedData: HowIsItUsed()
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/data/products/traditional-long-term-care/TraditionalLtcData.js